export const parse = (token) => {
    return JSON.parse(atob(token.split('.')[1]))
}

export const isExpired = (token) => {
    const expired = getExpired(token)
    return new Date(expired) < new Date()
}

export const getExpired = (token) => {
    const tokenInfo = parse(token)
    return tokenInfo.exp * 1000
}

export const getIssuedAt = (token) => {
    const tokenInfo = parse(token)
    return tokenInfo.iat * 1000
}